import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";

function Terms() {
  useEffect(() => {});

  return (
    <div className="mt-[81px] mb-[200px]">
      <p className="text-center">Terms and Conditions</p>
    </div>
  );
}

export default Terms;
